<template>
  <div class="staker-stake">
    
    <div class="overview overview-bottom">
      <div class="rtitle">
        <div class="icon">
          <img src="../assets/eth.png" />
        </div>
        <div class="rtitle-text">
          rETH
        </div>
      </div>
      <div class="rstatus">
        <div class="amount">
          {{ rethAmountShow }}
        </div>
        <div class="operation-btn btn-active" @click="uniTrade">
          Trade
        </div>
        <div class="operation-btn operation-btn2" :class="{'btn-active': redeemActiveStatus == 1}" @click="redeem">
          Redeem
        </div>
      </div>
      <div class="rdesc">
        Your current staked ETH  is {{ stakedEth }}
      </div>
    </div>

    <div class="overview">
      <div class="rtitle">
        <div class="icon">
          <img src="../assets/eth.png" />
        </div>
        <div class="rtitle-text">
          rETH / ETH
        </div>
      </div>
      <div class="rstatus">
        <div class="amount">
          {{ ratioShow }}
        </div>
        <div class="operation-btn operation-btn3 btn-active" @click="$emit('stake')">
          Stake
        </div>
      </div>
      <div class="rdesc">
        Updated every 8 hours
      </div>
    </div>

  </div>
</template>

<script>
import { Toast } from 'mint-ui';
import Web3Util from '../util/web3Util.js';
import NumberUtil from '../util/numberUtil.js';

const defaultAmount = '--';
const defaultRatio = '--';

export default {
  name: 'stakerStaked',
  props: {
    rethData: {
      type: Object,
      default: function() {
        return {
          address: '',
          rethBalance: '0' 
        };
      }
    }
  },
  data() {
    let lang = window.localStorage.getItem('lang');
    let address = '';
    let rethAmount = defaultAmount;
    let rethAmountShow = defaultAmount;
    return {
      lang: lang,
      address: address,
      ratio: defaultRatio,
      ratioShow: defaultRatio,
      rethAmount: rethAmount,
      rethAmountShow: rethAmountShow,
      stakedEth: '-',
      redeemActiveStatus: 0
    }
  },
  methods: {
    uniTrade() {
      window.open('https://info.uniswap.org/pair/0x5f49da032defe35489ddb205f3dc66d8a76318b3');
    },
    redeem() {
      Toast({ 
        message: 'Redemption will be available once Phase 1.5 of ETH2 lives.', 
        duration: 3000 
      });
    },
    calculateStakedEth() {
      if (this.rethAmount != defaultAmount && this.ratio != defaultRatio) {
        this.stakedEth = NumberUtil.handleEthGweiToFixed(this.rethAmount * this.ratio);
      }
    }
  },
  created() {
    if (ethereum.selectedAddress) {
      this.address = ethereum.selectedAddress;
      let web3 = Web3Util.getWeb3();
      let contract = new web3.eth.Contract(Web3Util.getRETHTokenAbi(), Web3Util.getRETHTokenAddress(), {
        from: this.address
      });

      contract.methods.balanceOf(this.address).call().then(result => {
        this.rethAmount = web3.utils.fromWei(result, 'ether');
        this.rethAmountShow = NumberUtil.handleEthGweiToFixed(this.rethAmount);
        this.calculateStakedEth();
      });

      const amount = web3.utils.toWei('1');
      contract.methods.getEthValue(amount).call().then(result => {
        this.ratio = web3.utils.fromWei(result, 'ether');
   
        let count = 0;
        let totalCount = 10;
        let ratioAmount = 0;
        let piece = this.ratio / totalCount;
        let interval = setInterval(() => {
          count++;
          ratioAmount += piece;
          if (count == totalCount) {
            ratioAmount = this.ratio;
            window.clearInterval(interval);
          }
          this.ratioShow = NumberUtil.handleEthAmountRateToFixed(ratioAmount);
        }, 100);
        
        
        this.calculateStakedEth();
      });
    }
    
  }
};
</script>

<style lang="scss">

.staker-stake {

  .overview-bottom {
    padding-bottom: 50px;
    border-bottom: 1px solid #474747;
  }

  .overview {

    .rtitle {
      margin-top: 66px;
      display: flex;

      .icon {
        height: 36px;
        img {
          height: 100%;
        }
      }

      .rtitle-text {
        margin-left: 10px;
        font-size: 30px;
        font-weight: bold;
      }
    }

    .rstatus {
      display: flex;
      margin-top: 20px;
      margin-left: 56px;

      .amount {
        font-size: 30px;
        color: #00F3AB;
        font-weight: bold;
        width: 280px;
      }

      .operation-btn {
        cursor: pointer;
        width: 69px;
        height: 28px;
        line-height: 28px;
        font-size: 12px;
        color: #23292F;
        font-weight: bold;
        background-color: #00F3AB;
        opacity: 0.4;
        border-radius: 13px;
        text-align: center;
      }

      .operation-btn2 {
        margin-left: 11px;
      }

      .operation-btn3 {
        margin-left: 74px;
      }

      .btn-active {
        opacity: 1;
      }
    }

    .rdesc {
      margin-top: 50px;
      margin-left: 56px;
      font-size: 16px;
      color: #C4C4C4;
    }
  }

}
  
</style>